<template>
    <hts-modal
        :show="show"
        :title="$t('labels.workflowModule.delete')"
        type="confirm"
        :content="$t('labels.workflowModule.confirmDelete')"
        @hide="closeOverSide"
        @confirm="() => handleSubmit()" />
</template>
<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  workflow: {
    type: Object || Array
  }
})

const { workflow } = toRefs(props)

const emits = defineEmits(['close', 'refreshTables', 'resetWorkflowSelected'])

const closeOverSide = () => {
  emits('close')
}

const handleSubmit = () => {
  if (!workflow || !workflow.value) {
    return
  }
  const api = $urlAdmin.workflow.delete
  $api(api, { body: workflow.value }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.deleteSuccess'))
      if (Array.isArray(workflow)) {
        emits('resetWorkflowSelected')
      }
      emits('close')
    }
  })
}
</script>
